import { useEffect, useState } from 'react';

// Categorias que solo se muestran en un horario. Se usa la hora local del iPad.
// days: 0 = domingo ... 6 = sabado. from/to en minutos desde medianoche; `to`
// es exclusivo (a las 14:00 ya no se muestra).
const LUNCH = { days: [1, 2, 3, 4, 5], from: 11 * 60, to: 14 * 60 };

const SCHEDULES = [
    { match: ['LUNCH', 'L FAJITAS', 'L STEAKS'], ...LUNCH },
];

const scheduleFor = (category) => {
    const name = (category?.name || '').toUpperCase().trim();
    return SCHEDULES.find((schedule) => schedule.match.some((word) => name.startsWith(word)));
};

export const isCategoryVisible = (category, now = new Date()) => {
    const schedule = scheduleFor(category);
    if (!schedule) return true;

    const minutes = now.getHours() * 60 + now.getMinutes();
    return schedule.days.includes(now.getDay()) && minutes >= schedule.from && minutes < schedule.to;
};

export const visibleCategories = (categories = [], now = new Date()) =>
    categories.filter((category) => isCategoryVisible(category, now));

// Re-renderiza cada 30s para que las categorias aparezcan/desaparezcan solas
export const useNow = (intervalMs = 30000) => {
    const [now, setNow] = useState(() => new Date());

    useEffect(() => {
        const timer = setInterval(() => setNow(new Date()), intervalMs);
        return () => clearInterval(timer);
    }, [intervalMs]);

    return now;
};
